import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    gdcEnabled: Boolean
  }

  connect() {
    this.disableGdcOption();
  }

  disableGdcOption() {
    if (this.gdcEnabledValue) return;

    const gdcOption = this.element.querySelector(`input[value='GENSDECONFIANCE_ANCIEN']`)
    gdcOption.disabled = true
  }
}
